import { motion } from "framer-motion";
import { ArrowDownRight } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/9cc487d1-0562-49fe-8408-0b095d1ddc37/images/f8b8ef9ddb66ba6911d0473eb72cb7fe98ba4f8794c77e6a63b07622a36368d9.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/95 via-[#050505]/60 to-[#050505]/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]/50" />
      {/* Grain */}
      <div className="grain absolute inset-0" />

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 pt-40 pb-24 min-h-screen flex flex-col justify-between">
        {/* Top label row */}
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="flex items-center justify-between"
        >
          <span className="text-[11px] tracking-[0.3em] uppercase text-[#155E63] font-bold">
            Aevum / Vol. I
          </span>
          <span className="hidden sm:block text-[11px] tracking-[0.3em] uppercase text-[#A3A3A3]">
            Endless Time — Engineered Movement
          </span>
        </motion.div>

        {/* Massive title */}
        <div className="flex-1 flex flex-col justify-center mt-16">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.4, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="font-display font-light text-[18vw] sm:text-[16vw] lg:text-[14vw] leading-[0.85] tracking-tighter text-[#F5F2EA]"
          >
            <span className="block">Aevum.</span>
            <span className="block italic text-[#F5F2EA]/35 -mt-2 text-[16vw] sm:text-[14vw] lg:text-[12vw]">timeless</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.2, delay: 1 }}
            className="mt-12 max-w-md text-base sm:text-lg leading-relaxed text-[#A3A3A3] font-light"
          >
            Performance garments shaped by the idea that time is not a limit —
            it is the canvas. Move freely. Move strongly.
          </motion.p>
        </div>

        {/* Bottom row */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.2 }}
          className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-8 pt-12 border-t border-white/10"
        >
          <div className="max-w-sm">
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#155E63] font-bold mb-3">
              Chapter 01
            </p>
            <p className="font-display text-2xl sm:text-3xl leading-tight text-[#F5F2EA]">
              Built for the runners of every hour.
            </p>
          </div>

          <a
            href="#ethos"
            data-testid="hero-cta"
            className="group inline-flex items-center gap-3 text-[12px] tracking-[0.3em] uppercase text-[#F5F2EA] border border-[#F5F2EA]/30 px-6 py-4 hover:bg-[#F5F2EA] hover:text-[#050505] hover:border-[#F5F2EA] transition-all duration-500 hover:-translate-y-0.5"
          >
            Discover the Ethos
            <ArrowDownRight
              size={16}
              className="group-hover:translate-x-1 group-hover:translate-y-1 transition-transform"
            />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
